<ol>
  <li>
    Zapoznałem/am się z regulaminem e-usługi: <strong>{{ application()?.regulations ? 'Tak' : 'Nie' }}</strong>
  </li>
  <li>
    Zapoznałem/am się z klauzulą informacyjną RODO: <strong>{{ application()?.clause ? 'Tak' : 'Nie' }}</strong>
  </li>
  @if (showElectronicCorrespondenceConsent()) {
    <li>
      Wyrażam zgodę na doręczanie korespondencji w niniejszej sprawie za pomocą środków komunikacji
      elektronicznej w rozumieniu art. 2 pkt 5 ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną
      (Dz. U. z 2020 r. poz. 344):
      <strong>{{ application()?.electronicCorrespondenceConsent ? 'Wyrażam zgodę' : 'Nie wyrażam zgody' }}</strong>
    </li>
  }
  <li>
    Wyrażam zgodę na korzystanie z mojego numeru telefonu w celach informacyjnych:
    <strong>{{ application()?.phoneInformationConsent ? 'Wyrażam zgodę' : 'Nie wyrażam zgody' }}</strong>
  </li>
  @if (application()?.partialTypeExemption === 'Karta dużej rodziny') {
    <li>
      Oświadczam, że na nieruchomości wskazanej w deklaracji o wysokości opłaty za
      gospodarowanie odpadami komunalnymi zamieszkuje(-ją) rodzina(-ny) wielodzietna(-ne),
      o której(-rych) mowa w ustawie o Karcie Dużej Rodziny:
      <strong>Tak</strong>
    </li>
  }
</ol>
